import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as feeTypeFragment } from './feeType';
import { api as semSectionFragment } from './semSection';

export const api = gql`
  fragment SemItineraryFragment on SemItinerary {
    fees {
      type {
        ...FeeTypeInfo
      }
      price {
        ... on Money {
          amount
          currency
        }
      }
    }
    ticketsLeft
    legs {
      segments {
        baggageCondition
        carrier {
          id
          name
        }
        duration
        sections {
          ...SemSection
        }
        transportTypes
      }
    }
    transportTypes
  }
  ${feeTypeFragment}
  ${semSectionFragment}
`;
